import {SelectionModel} from '@angular/cdk/collections';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {Roles} from '../../../models/Roles';
import {SchoolLevel, SchoolUnit} from '../../../models/School';
import {CommonService} from '../../../services/common.service';
import {ExcelService} from '../../../services/excel.service';
import {RolesService} from '../../../services/roles.service';
import {StaffService} from '../../../services/staff.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {SendSmsDialogComponent} from '../../shared/send-sms-dialog/send-sms-dialog.component';
import {FormUsersAssignmentComponent} from './form-users-assignment/form-users-assignment.component';

@Component({
    selector: 'app-staff',
    templateUrl: './staff.component.html',
    styleUrls: ['./staff.component.scss']
})
export class StaffComponent implements OnInit {
    pageTitle: string;
    staffMembers: MatTableDataSource<any> = new MatTableDataSource<any>();
    isLoading: boolean;
    displayColumns = ['select', 'registrationNo', 'first_name', 'last_name', 'email', 'telephone', 'roles', 'position', 'specialty', 'school_unit_description', 'school_level_description'];
    selection: SelectionModel<any>;
    roles: Roles[];
    units: SchoolUnit[];
    levels: SchoolLevel[];
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
    @ViewChild(MatSort, {static: true}) sort: MatSort;

    constructor(private staffService: StaffService,
                public dialog: MatDialog,
                public excelService: ExcelService,
                private rolesService: RolesService,
                public commonService: CommonService,
                public toastMessagesService: ToastMessagesService) {
        this.pageTitle = 'Εργαζόμενοι';
        this.isLoading = false;
        this.selection = new SelectionModel<any>(true, []);
    }

    async ngOnInit() {
        try {
            this.loadingAction(1);
            await this.initStaffMembers();
            await this.loadingRoles();
            await this.loadingSchoolUnits();
            await this.loadingSchoolLevels();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.loadingAction(0);
        }
    }


    loadingAction(status) {
        if (status === 1) {
            this.isLoading = true;
        } else {
            this.isLoading = false;
        }
    }

    equals(objOne, objTwo) {
        if (typeof objOne !== 'undefined' && typeof objTwo !== 'undefined') {
            return objOne.id === objTwo.id;
        }
    }

    async initStaffMembers() {
        try {
            const members = await this.staffService.getStaffMembers();
            for (const member of members) {
                member.initialRoles = member.roles;
                member.initialLevels = member.levels || [];
                member.initialUnits = member.units || [];
            }
            this.staffMembers = new MatTableDataSource<any>(members);
            this.staffMembers.paginator = this.paginator;
            this.staffMembers.sort = this.sort;
            this.commonService.setPaginatorTexts(this.paginator);
        } catch (e) {
            throw e;
        }
    }

    async loadingRoles() {
        try {
            this.roles = await this.rolesService.getRoles();
        } catch (e) {
            throw e;
        }
    }

    async loadingSchoolUnits() {
        try {
            const unitsRequest = await this.commonService.getList(`common/school-unit`);
            this.units = unitsRequest.object;
        } catch (e) {
            throw e;
        }
    }

    async loadingSchoolLevels() {
        try {
            const levelsRequest = await this.commonService.getList(`common/school-levels`);
            this.levels = levelsRequest.object;
        } catch (e) {
            throw e;
        }
    }

    public masterToggle(): void {
        // @ts-ignore
        this.isAllSelected() ? this.selection.clear() : this.staffMembers.data.forEach((row) =>
            this.selection.select(row));
    }

    public isAllSelected(): boolean {
        const numSelected = this.selection.selected.length;

        // @ts-ignore
        const numRows = this.staffMembers.data.length;

        return numSelected === numRows;
    }

    searchStaff(value: any) {
        this.staffMembers.filter = value.trim().toLowerCase();
    }

    assignFormToSelectedStaffMembers() {
        const users = this.selection.selected as any[];
        this.dialog.open(FormUsersAssignmentComponent, {
            width: '70%',
            height: '95%',
            disableClose: true,
            hasBackdrop: true,
            data: {
                users
            }
        });
    }

    exportToExcel() {
        const {staff, columns} = this.formatStaffModel();
        this.excelService.exportAsCustomExcelFile(staff, 'Εργαζόμενοι', columns);
    }

    formatStaffModel() {
        const staff = [];
        for (const member of this.staffMembers.data) {
            const model = {
                registrationNumber: member.registrationNo,
                lastName: member.last_name,
                firstName: member.first_name,
                email: member.email,
                telephone: member.telephone,
                position: member.position,
                specialty: member.specialty,
                school_level_description: member.school_level_description,
                school_unit_description: member.school_unit_description,
            };
            staff.push(model);
        }

        const columns = [
            {
                key: 'registrationNumber',
                label: 'Αριθμός μητρώωου',
            },
            {
            key: 'lastName',
            label: 'Επώνυμο',
        },
            {
                key: 'firstName',
                label: 'Όνομα',
            },
            {
                key: 'email',
                label: 'Email',
            },
            {
                key: 'telephone',
                label: 'Τηλέφωνο',
            },
            {
                key: 'position',
                label: 'Θέση',
            },
            {
                key: 'specialty',
                label: 'Ειδικότητα',
            },
            {
                key: 'school_unit_description',
                label: 'Σχολική μονάδα',
            },
            {
                key: 'school_level_description',
                label: 'Σχολείο - Βαθμίδα',
            }
        ];

        return {staff, columns};
    }

    async changeRole(element) {
        const toBeRemoved = [];
        const toBeInserted = [];

        //  Find roles to delete
        for (const role of element.initialRoles) {
            const exists = element.roles.find(r => r.id === role.id);
            if (!exists) {
                toBeRemoved.push(role);
            }
        }

        //  Find roles to insert
        for (const role of element.roles) {
            const exists = element.initialRoles.find(r => r.id === role.id);
            if (!exists) {
                toBeInserted.push(role);
            }
        }

        const relation = {
            userId: element.id,
            newRoles: toBeInserted,
            deleteRoles: toBeRemoved
        };

        try {
            await this.staffService.updateStaffRole(relation);
            this.toastMessagesService.toastMessages(`Οι ρόλοι για τον χρήστη ${element.first_name} ${element.last_name} ενημερώθηκαν με επιτυχία`);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(`${e.message}`);
        }
    }

    async changeSchoolLevel(member: any) {
        const levels = JSON.stringify(member.levels);
        try {
            await this.staffService.updateMemberLevels(levels, member.id);
            this.toastMessagesService.toastMessages(`Τα σχολεία για τον χρήστη ${member.first_name} ${member.last_name} ενημερώθηκαν με επιτυχία`);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(`${e.message}`);
        }
    }

    async changeSchoolUnit(member: any) {
        const units = JSON.stringify(member.units.map(unit => unit.college_school_unit_id));
        try {
            await this.staffService.updateMemberUnits(units, member.id);
            this.toastMessagesService.toastMessages(`Οι σχολικές μονάδες για τον χρήστη ${member.first_name} ${member.last_name} ενημερώθηκαν με επιτυχία`);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(`${e.message}`);
        }
    }

    displayLevelName(level: SchoolLevel) {
        return level.unit_description ? `${level.description} - ${level.unit_description}` : `${level.description}`;
    }

    checkInitialMemberLevel(member, level) {
        return member.college_school_id === level.college_school_id && member.college_school_unit_id === level.college_school_unit_id;
    }

    sendSMS() {
        const users = this.selection.selected as any[];
        this.dialog.open(SendSmsDialogComponent, {
            disableClose: true,
            hasBackdrop: true,
            panelClass: 'no-overflow',
            data: {
                users,
                mode: 'users'
            }
        });
    }
}
